import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

export type MessageDialogType = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-message-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent {
  @Input() type: MessageDialogType = 'info';
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() confirmButtonMsg: string = 'ตกลง';

  constructor(public activeModal: NgbActiveModal) {
  }

  close() {
    this.activeModal.close(true);
  }
}
